//angular imports
import { ActivatedRoute, Router } from "@angular/router";

//local imports
import {
  BreadcrumbChangedMessage,
  IBreadcrumbItemModel,
  Messenger,
} from "@app/shared";
import {
  CatalogConstants,
  CategoryModel,
  DepartmentModel,
  ProgramModel,
  ProjectModel,
  RoomModel,
  CatalogStateService
} from "@app/catalog";
import { CatalogCommonConstants, SelectCategoryMessage, SelectDepartmentMessage, SelectProgramMessage, SelectProjectMessage, SelectRoomMessage } from "@app/catalog-common";

export class CatalogRouteStateHandler {

    private catalogStateService: CatalogStateService;
    private messenger: Messenger;
    private router: Router;

    constructor(
    ) {}

    public initialize(
        catalogStateService: CatalogStateService, 
        messenger: Messenger, 
        route: ActivatedRoute, 
        router: Router) {

        this.catalogStateService = catalogStateService;
        this.messenger = messenger;
        this.router = router;

        messenger.subscribe(this, BreadcrumbChangedMessage, (msg) => {
            if(msg.breadcrumbName !== CatalogConstants.CATALOG) return;

            this.syncBreadcrumbsToRoute(msg.breadcrumbs, route);
        });

        this.initializeStateFromRoute(route);
    }

    private syncBreadcrumbsToRoute(breadcrumbs: IBreadcrumbItemModel[], route: ActivatedRoute): void {
        const categoryIds: string[] = [];
        const departmentIds: string[] = [];
        const roomIds: string[] = [];
        const programIds: string[] = [];
        const projectIds: string[] = [];
        const searchList: string[] = [];

        breadcrumbs.forEach(item => {
            if (item instanceof RoomModel) {
            roomIds.push(item.id);
            } 
            else if (item instanceof DepartmentModel) {
            departmentIds.push(item.id);
            } 
            else if (item instanceof CategoryModel) {
            categoryIds.push(item.id);
            } 
            else if (item instanceof ProgramModel) {
            programIds.push(item.id);
            } 
            else if (item instanceof ProjectModel) {
            projectIds.push(item.id);
            }
        });

        const queryParams: any = {
            ...route.snapshot.queryParams,
            categoryId: categoryIds.length > 0 ? categoryIds.join(',') : null,
            departmentId: departmentIds.length > 0 ? departmentIds.join(',') : null,
            roomId: roomIds.length > 0 ? roomIds.join(',') : null,
            programId: programIds.length > 0 ? programIds.join(',') : null,
            projectId: projectIds.length > 0 ? projectIds.join(',') : null,
            search: searchList.length > 0 ? searchList.join(','): null
        };

        this.router.navigate([], {
            relativeTo: route,
            queryParams,
            queryParamsHandling: 'merge',
        });
    }

    private async initializeStateFromRoute(route: ActivatedRoute): Promise<void> {

        const queryParams = route.snapshot.queryParams;
        await this.catalogStateService.loadCarousels();

        if (!Object.keys(queryParams).length) {
            return;
        }

        const parseList = (key: string) => (queryParams[key] as string || '').split(',').filter(id => !!id);

        const categoryIds   = parseList(CatalogCommonConstants.ROUTE_PARAMS.CATEGORY_ID);
        const departmentIds = parseList(CatalogCommonConstants.ROUTE_PARAMS.DEPARTMENT_ID);
        const roomIds       = parseList(CatalogCommonConstants.ROUTE_PARAMS.ROOM_ID);
        const programIds    = parseList(CatalogCommonConstants.ROUTE_PARAMS.PROGRAM_ID);
        const projectIds    = parseList(CatalogCommonConstants.ROUTE_PARAMS.PROJECT_ID);
        const searchList    = parseList(CatalogCommonConstants.ROUTE_PARAMS.SEARCH_KEY);


        const categories = this.catalogStateService.CatalogManagementState.categories().filter(item => categoryIds.includes(item.id));
        const departments = this.catalogStateService.CatalogManagementState.departments().filter(item => departmentIds.includes(item.id));
        const rooms = this.catalogStateService.CatalogManagementState.rooms().filter(item => roomIds.includes(item.id));
        const programs = this.catalogStateService.CatalogManagementState.programs().filter(item => programIds.includes(item.id));
        const projects = this.catalogStateService.CatalogManagementState.projects().filter(item => projectIds.includes(item.id));

        if(categories.length) {
            this.messenger.send(new SelectCategoryMessage(categories[0]));
        }

        if(departments.length) {
            this.messenger.send(new SelectDepartmentMessage(departments[0]));
            console.log("Called SelectDepartmentMessage")
        }

        if(rooms.length) {
            this.messenger.send(new SelectRoomMessage(rooms[0]));
        }

        if(programs.length) {
            this.messenger.send(new SelectProgramMessage(programs[0]));
        }

        if(projects.length) {
            this.messenger.send(new SelectProjectMessage(projects[0]));
        }
    }
}